import {PLAYER_COLORS} from "./colors";

/**
 * Пары похожих цветов игроков: два цвета из одной пары стараются не выдавать
 * в одной партии, чтобы игроков нельзя было перепутать по флагам и отрядам
 * (см. pickPlayerColor). Список правится вручную — достаточно добавить или
 * убрать пару, порядок цветов внутри пары значения не имеет.
 *
 * HEX-значения см. в COLORS_CONFIG (colors.js).
 */
export const SIMILAR_PLAYER_COLOR_PAIRS = [
  // Синие: #26619C и #56b4ff — один тон, отличается только светлота
  [PLAYER_COLORS.BLUE, PLAYER_COLORS.SKY_BLUE],
  // Синий и индиго: #3a7cbd и #4455ff
  [PLAYER_COLORS.BLUE, PLAYER_COLORS.INDIGO],
  // Индиго и фиолетовый: #4455ff и #7b00d1
  [PLAYER_COLORS.INDIGO, PLAYER_COLORS.VIOLET],
  // Голубой и бирюзовый: #56b4ff и #00cfc1
  [PLAYER_COLORS.SKY_BLUE, PLAYER_COLORS.CELADON],
  // Зеленые: темный #249145 и салатовый #7bbf34
  [PLAYER_COLORS.DARK_GREEN, PLAYER_COLORS.LIGHT_GREEN],
  // Темно-зеленый и коричневый: #249145 и #934c00
  [PLAYER_COLORS.DARK_GREEN, PLAYER_COLORS.BROWN],
  // Фиолетовый и пурпурный: #7b00d1 и #9e0076
  [PLAYER_COLORS.VIOLET, PLAYER_COLORS.PURPLE],
  // Пурпурный и розовый: #9e0076 и #ff67dc
  [PLAYER_COLORS.PURPLE, PLAYER_COLORS.PINK],
  // Серые: #757575 и #a1a1a1
  [PLAYER_COLORS.GREY, PLAYER_COLORS.LIGHT_GREY],
  // Светло-серый и костяной: #a1a1a1 и #ccb5a2
  [PLAYER_COLORS.LIGHT_GREY, PLAYER_COLORS.BONE],
  // Костяной и светло-коричневый: #ccb5a2 и #ab7646
  [PLAYER_COLORS.BONE, PLAYER_COLORS.LIGHT_BROWN],
  // Коричневые: #ab7646 и #502700
  [PLAYER_COLORS.LIGHT_BROWN, PLAYER_COLORS.BROWN],
  // Светло-коричневый и оранжевый: #ab7646 и #e68b01
  [PLAYER_COLORS.LIGHT_BROWN, PLAYER_COLORS.ORANGE],
  // Оранжевый и желтый: #e68b01 и #F5CC00
  [PLAYER_COLORS.ORANGE, PLAYER_COLORS.YELLOW],
];

// color -> Set похожих на него цветов (симметрично, строится один раз)
const SIMILAR_COLORS_BY_COLOR = SIMILAR_PLAYER_COLOR_PAIRS.reduce((acc, [colorA, colorB]) => {
  if (!acc[colorA]) acc[colorA] = new Set();
  if (!acc[colorB]) acc[colorB] = new Set();
  acc[colorA].add(colorB);
  acc[colorB].add(colorA);
  return acc;
}, {});

/**
 * Похожи ли два цвета игроков (см. SIMILAR_PLAYER_COLOR_PAIRS)
 * @param {string} colorA
 * @param {string} colorB
 * @returns {boolean}
 */
export const checkIfPlayerColorsSimilar = (colorA, colorB) => {
  return Boolean(SIMILAR_COLORS_BY_COLOR[colorA]?.has(colorB));
};
